const join = (by: string) => <T>(source: T[]) => source.join(by);

export default join;
